export function formatCurrency(value) {
    value = value || '';
    let parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

//function to get the cookie consent value from local storage and return its value
export function getCookieConsent(){
    try {
        return localStorage.getItem("cookie_consent_consent_given");
    } catch(e) {
        return 'false';
    }
}

export function getAmplitudeApiKey() {
    return '6d43cbdb707a46ff32e4fb441a69ae75'; //live relaunch api key
}

export function shouldSendToAmplitude(cookieConsent){
    if (cookieConsent != 'true') {
        return false;
    }
    //check if authorised cookie exists, if cookie exists return true immediately regardless of valid time window
    //cookie returns -1 if it does not exists
    if(document.cookie.indexOf('amplitude-event-pass') !== -1) {
        return true;
    }
    //check if event block cookie exists, if cookie exists return false immediately regardless of valid time window
    //cookie returns -1 if it does not exists
    if(document.cookie.indexOf('amplitude-event-block') !== -1) {
        return false;
    }
    //value between 0-100 representing % of time per hour amplitude events can be sent examples below
    /* -------------------------------
    [percentage | eventTimeWindow ]
    [100        | 60 minutes      ]
    [50         | 30 minutes      ]
    [25         | 15 minutes      ]
    [10         | 6 minutes       ]
    -------------------------------
    */
    let eventWindowPercentage = 0;
    //the event window cut off minute before events are ignored
    let eventWindowTime = (60 * eventWindowPercentage) / 100;
    let currentDate = new Date;
    let currentMinute = currentDate.getMinutes();
    //check if the current minute of the hour is out of the send time window and if is return false and add event block cookie
    if (currentMinute > eventWindowTime){
        document.cookie = "amplitude-event-block=true;" + "path=/";
        return false;
    }
    /*  check if the current minute of the hour is in the event send time window and the cookie consent is set to true
        add a cookie so that a user is authrosied for the current session until browser is closed to avoid event loss
    */
    if (currentMinute <= eventWindowTime && cookieConsent === 'true'){
        // Set the cookie
        document.cookie = "amplitude-event-pass=authorised;" + "path=/";
        return true;
    }
} 
